require 'isomorphic-fetch'
extend = require 'extend'
{ doFlash } = require './flash'
{ refreshToken } = require './token'

# This is from https://github.com/github/fetch
# We don't have to use it, but it seemed like a good way to have control, and
# I also liked using .catch() instead of passing a second argument to .then
# for error cases
checkStatus = (response) ->
	if response.status >= 200 and response.status < 300
		response
	else if response.status == 401 && !response.url.match(/user_token/)
		window.location.href = '/logout'
	else
		error = new Error(response.statusText)
		error.response = response
		throw error

parseJson = (response) ->
	response.json()

# If you're making an API call to anywhere but our server, you should
# set 'includeToken' to false in the extraOptions.
fetchJson = (url, fetchOptions = {}, extraOptions = {}, dispatch = null) ->
	defaultFetchOptions =
		method: 'get'
		body: null
		headers:
			'Accept': 'application/json'
			'Content-Type': 'application/json'
	modifiedFetchOptions = extend {}, defaultFetchOptions, fetchOptions

	if extraOptions.token
		modifiedFetchOptions.headers['Authorization'] = 'Bearer ' + extraOptions.token
	else unless extraOptions.includeToken == false
		token = null
		try
			authItem = JSON.parse localStorage.getItem('auth')
			token = authItem.token
		catch
		if token
			modifiedFetchOptions.headers['Authorization'] = 'Bearer ' + token

	modifiedFetchOptions.body = JSON.stringify fetchOptions.body if fetchOptions.body
	fetch url, modifiedFetchOptions
	.then (response) ->
		token = response.headers?.get('Authorization')
		if dispatch && token
			dispatch(refreshToken(token))
		response
	.then checkStatus
	.then parseJson

fail = (type, message) ->
	type: type
	error: true
	payload:
		error: message

success = (type, list) ->
	type: type
	payload:
		list: list

doAction = (url, method, body, doingActionType, didActionType, failureMessage = null, successMessage = null, getSuccessPayload = null) ->
	(dispatch, getState) ->
		# In testing, `getState().auth` is undefined
		extraOptions = if getState().auth? then { token: getState().auth.token } else {}
		dispatch { type: doingActionType }
		fetchJson url, {
			method: method,
			body: body
		}, extraOptions
		.then (responseJson) ->
			if responseJson.status == 'success'
				dispatch doFlash('success', 'Success!', successMessage) if successMessage
				if getSuccessPayload
					dispatch
						type: didActionType
						payload: getSuccessPayload(responseJson)
				else
					dispatch success(didActionType, responseJson.data.list)
			else if response.status == 401
				console.warn('User was logged out from server')
			else
				# The `failureMessage` parameter doesn't need to be present to present a flash message upon failure,
				# but if the caller hasn't specified a failure message, they presumably don't want the user to be
				# aware of the success/failure of this action in any way
				dispatch doFlash('error', 'Error!', responseJson.message) if failureMessage
				dispatch fail(didActionType, responseJson.message)
		, (error) ->
			console.log error
			dispatch doFlash('error', 'Error!', failureMessage) if failureMessage
			dispatch fail(didActionType, error.response['statusText'])
			Promise.reject error

doActionWithServerValidations = (url, method, body, doingActionType, didActionType, failureMessage, successMessage = null, getSuccessPayload = null) ->
	# Some of our POST/PATCH calls use server-side validations, so this function returns validation errors
	# as part of the rejected promise if the API call fails.  The returned error is formatted to be usable
	# by redux-form to properly display errors.
	# This also doesn't show flash messages when the request fails, since redux-form handles notification that
	# there were errors.
	(dispatch, getState) ->
		dispatch { type: doingActionType }
		# We wrap with an extra promise, so that if there is a failure, no subsequent "then"'s will run after our catch block.
		new Promise (resolve, reject) ->
			fetchJson url,
				method: method,
				body: body
			.then (responseJson) ->
				if responseJson.status == 'success'
					dispatch doFlash('success', 'Success!', successMessage) if successMessage
					if getSuccessPayload
						dispatch
							type: didActionType
							payload: getSuccessPayload responseJson
					else
						dispatch success(didActionType, responseJson.data.list)
				else
					dispatch doFlash('error', 'Error!', responseJson.message)
					dispatch fail(didActionType, responseJson.message)
				resolve(responseJson.data)
			, (error) ->
				dispatch fail(didActionType, error.response['statusText'])
				reject error.response.json()

module.exports = {
	doAction
	doActionWithServerValidations
	fail
	fetchJson
	success
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/index.coffee